import React from "react";

import styled from "@emotion/styled";

const OpeningHours = ({ openTimes }) => {
    const weekdays = ["mo", "di", "mi", "do", "fr", "sa", "so"];

    const StyledSpan = styled.span`
        text-transform: capitalize;
    `;

    return (
        <>
            {openTimes.map((openTime, index) => {
                let start = null;
                let end = null;
                weekdays.forEach((day) => {
                    if (openTime[day] === true) {
                        if (start === null) {
                            start = day;
                        }
                        end = day;
                    }
                });
                return (
                    <div key={index}>
                        {start === end ? (
                            <>
                                <StyledSpan>{start}</StyledSpan>:
                            </>
                        ) : (
                            <>
                                {" "}
                                <StyledSpan>{start}</StyledSpan> -{" "}
                                <StyledSpan>{end}</StyledSpan>:{" "}
                            </>
                        )}{" "}
                        {openTime["24h"] === true ? (
                            "24 Stunden geöffnet"
                        ) : (
                            <>
                                {openTime.von === "" &&
                                openTime.bis === "" &&
                                openTime.danach_ueber_tankautomat === true ? (
                                    "über Tankautomat"
                                ) : (
                                    <>
                                        {openTime.von} bis {openTime.bis}
                                        {openTime.danach_ueber_tankautomat ===
                                            true && (
                                            <>
                                                <br />
                                                danach über Tankautomat
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default OpeningHours;
